import { saveAs } from "file-saver/FileSaver";
import { HttpResponse } from "@angular/common/http";

/**
 * Saves a file by opening file-save-as dialog in the browser
 * using file-save library.
 * @param blobContent file content as a Blob
 * @param fileName name file should be saved as
 */
export const saveFile = (blobContent: Blob, fileName: string) => {
  const blob = new Blob([blobContent], { type: "application/octet-stream" });
  console.log(fileName.replace(/\"/g, ""));
  saveAs(blob, fileName.replace(/\"/g, ""));
};

/**
 * Derives file name from the http response
 * by looking inside content-disposition
 * @param res http Response
 */
export const getFileNameFromResponseContentDisposition = (
  res: HttpResponse<any>,
  baseName: string
) => {
  let fileName = baseName;
  const headerValue = res.headers.get("Content-Disposition");
  if (headerValue) {
    const matches = /filename=([^;]+)/gi.exec(headerValue);
    fileName = (matches[1] || baseName).trim();
  }
  return fileName;
};

export const checkIfTruncated = (res: HttpResponse<any>): boolean => {
  const totalCount: number = parseInt(res.headers.get("X-Total-Count"), 10);
  const acceptRanges: number = parseInt(res.headers.get("Accept-Ranges"), 10);
  return totalCount > acceptRanges;
};



// WEBPACK FOOTER //
// ./src/app/services/utils/file-download-helper.ts